import {Preview, PreviewAction} from 'platform/components';
import {Box, HStack, Text, VStack, makeStorageUrl} from 'platform/foundation';

import {useGetFileByIdQuery} from '@dms/api/base';
import i18n from '@dms/i18n';

import {buildArray, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {PROMO_PHOTO_TILE_SIZE} from '../constants/PROMO_PHOTO_TILE_SIZE';

interface PromoPhotoTileProps extends RequiredTestIdProps {
  fileId: string;
  position: number;
  onPreview: () => void;
  onDelete: () => void;
}

export function PromoPhotoTile(props: PromoPhotoTileProps) {
  const {data: file} = useGetFileByIdQuery({fileId: props.fileId});

  return (
    <VStack spacing={1} width={PROMO_PHOTO_TILE_SIZE}>
      <Box
        position="relative"
        borderRadius="medium"
        overflow="hidden"
        border="1px solid"
        borderColor="general.separator"
      >
        <Box position="absolute" top={0} left={0}>
          <Box
            backgroundColor="palettes.neutral.900.100"
            borderRadius="small"
            paddingHorizontal={1}
          >
            <Text size="xSmall" color="white">
              {props.position + 1}
            </Text>
          </Box>
        </Box>

        <Preview
          url={file?.originalUri}
          makeUrl={makeStorageUrl}
          width={PROMO_PHOTO_TILE_SIZE}
          height={PROMO_PHOTO_TILE_SIZE}
          fit="cover"
          actions={buildArray<PreviewAction>()
            .add({
              icon: 'action/visibility',
              onClick: props.onPreview,
              'data-testid': suffixTestId('preview', props),
            })
            .add({
              icon: 'action/delete',
              onClick: props.onDelete,
              'data-testid': suffixTestId('delete', props),
            })}
          data-testid={suffixTestId('image', props)}
        />
      </Box>

      <HStack justify="center">
        <Text size="xSmall" color="tertiary">
          {i18n.t('entity.salesCampaign.labels.photoPosition', {position: props.position + 1})}
        </Text>
      </HStack>
    </VStack>
  );
}
